"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImportApiClient = createImportApiClient;
const axios_client_1 = require("@invivodf/axios-client");
function createImportApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function asyncImport(params) {
        const formData = new FormData();
        formData.append('file', params.file);
        await client.post(`/backoffice/v2/import/partners/${params.partnerId}/${params.importDomain}`, formData, {
            params: params.taskId,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
    return {
        asyncImport
    };
}
